import gql from 'graphql-tag'

export const CHATS_BY_USER = gql`
query chatsByUser($userId: ID!){
  chatsByUser(userId: $userId){
      name,
      jid,
      lastMessageTimestamp
    }
  }
`

export const MESSAGES_BY_CHAT = gql`
  query messagesByChat($remoteJid: String, $orderBy: String){
    messagesByChat(remoteJid: $remoteJid, orderBy: $orderBy) {
      edges {
        cursor
        node {
          text
          senderJid
          caption
          attachment
          thumbnail
          timestamp
          sender
          type
        }
      }
    }
  }
  `